export default __webpack_public_path__ + "static/media/newPlans.83b9862f.png";